'use strict';

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

export default Marionette.View.extend({

  tagName: 'button',
  className: 'button',
  template: require('./templates/button.hbs'),
  events: {
    'click': 'onClick',
  },

  initialize: function (options) {
    this.text = options.text || 'button';
  },

  serializeData: function () {
    return {
      text: this.text,
    };
  },

  onClick: function (evt) {
    evt.preventDefault();
    this.trigger('click');
  },

  addClass: function (className) {
    this.$el.addClass(className);
  },

  shouldShow: function () {
    return true;
  },

  toggleVisibility: function () {
    if (this.shouldShow()) {
      this.show();
    } else {
      this.hide();
    }
  },

  show: function () {
    this.$el.show();
  },

  hide: function () {
    this.$el.hide();
  },

  enable: function () {
    this.$el.prop('disabled', false);
  },

  disable: function () {
    this.$el.prop('disabled', true);
  },

});
